import { Typography } from "antd";
import React from "react";
import { FormSection, SectionContainer } from "../styles";
import { Variation, VariationCombination } from "../types";
import CombinationsTable from "./CombinationsTable";
import ProductVariations from "./ProductVariations";

const { Title } = Typography;

interface ProductDetailsSectionProps {
  productDetailsRef: React.RefObject<HTMLDivElement>;
  variations: Variation[];
  combinations: VariationCombination[];
  useVariationShipping: boolean;
  onAddVariation: () => void;
  onRemoveVariation: (key: number) => void;
  onVariationNameChange: (key: number, value: string) => void;
  onOptionChange: (
    variationKey: number,
    optionKey: number,
    value: string
  ) => void;
  onOptionKeyPress: (
    variationKey: number,
    e: React.KeyboardEvent<HTMLInputElement>
  ) => void;
  onRemoveOption: (variationKey: number, optionKey: number) => void;
  onDragStart: (e: React.DragEvent<HTMLDivElement>, optionKey: string) => void;
  onDragOver: (e: React.DragEvent<HTMLDivElement>) => void;
  onDrop: (e: React.DragEvent<HTMLDivElement>, targetOptionKey: string) => void;
  onCombinationChange: (index: number, field: keyof any, value: any) => void;
  onApplyToAll: (
    price: number,
    origin_price: number,
    stock: number,
    sku: string,
    weight?: number,
    length?: number,
    width?: number,
    height?: number
  ) => void;
  isEditing: boolean;
}

const ProductDetailsSection: React.FC<ProductDetailsSectionProps> = ({
  productDetailsRef,
  variations,
  combinations,
  useVariationShipping,
  onAddVariation,
  onRemoveVariation,
  onVariationNameChange,
  onOptionChange,
  onOptionKeyPress,
  onRemoveOption,
  onDragStart,
  onDragOver,
  onDrop,
  onCombinationChange,
  onApplyToAll,
  isEditing,
}) => {
  return (
    <SectionContainer ref={productDetailsRef}>
      <FormSection>
        <Title level={4}>Chi tiết sản phẩm</Title>

        <ProductVariations
          variations={variations}
          onAddVariation={onAddVariation}
          onRemoveVariation={onRemoveVariation}
          onVariationNameChange={onVariationNameChange}
          onOptionChange={onOptionChange}
          onOptionKeyPress={onOptionKeyPress}
          onRemoveOption={onRemoveOption}
          onDragStart={onDragStart}
          onDragOver={onDragOver}
          onDrop={onDrop}
        />

        {combinations.length > 0 && (
          <CombinationsTable
            combinations={combinations}
            variations={variations}
            useVariationShipping={useVariationShipping}
            onCombinationChange={onCombinationChange}
            onApplyToAll={onApplyToAll}
            isEditing={isEditing}
          />
        )}
      </FormSection>
    </SectionContainer>
  );
};

export default ProductDetailsSection;
